import React, { useState, useEffect } from "react";
import {
  Container,
  Row,
  Col,
  Form,
  Button,
  Card,
  Alert,
  Spinner,
} from "react-bootstrap";
import {
  Person,
  EnvelopeFill,
  TelephoneFill,
  BuildingFill,
  GeoAltFill,
  Globe,
  CreditCard,
  House,
  Briefcase,
  Calendar3,
  Tag,
} from "react-bootstrap-icons";
import FromPageIndicator from "../Common/FromPageIndicator";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import CustomAlert from "../CustomAlert/CustomAlert";

const PaymentPage = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    title: "",
    name: "",
    mobile: "",
    email: "",
    category: "",
    membershipId: "",
    institute: "",
    city: "",
    country: "",
    designation: "",
    postalAddress: "",
    postalPin: "",
    mealPreference: "veg",
    age: "",
    paymentAmount: 0,
    registrationType: "",
    payLater: false,
  });

  const [showError, setShowError] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [registrationSuccess, setRegistrationSuccess] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [fetched, setFetched] = useState(false);

  const regUserId =
    sessionStorage.getItem("userId") || localStorage.getItem("userId");

  const fetchUserData = async () => {
    if (regUserId) {
      try {
        const response = await fetch(
          `https://api.dremerz.net/api/DZ_8921_Ampicon_Create_Users_UserList/${regUserId}`,
          {
            method: "GET",
            headers: {
              "content-type": "application/json",
            },
          }
        );

        const data = await response.json();

        console.log(data);
        if (data.paymentStatus === "PAID") {
          navigate("/abstract-submission");
        }
        const regType = determineRegistrationType();
        const amount = calculatePaymentAmount(
          data.registrationCategory,
          regType
        );

        setFormData({
          title: data.userTitle || "",
          name: data.userName || "",
          mobile: data.mobileNumber || "",
          email: data.emailId || "",
          category: data.registrationCategory || "",
          membershipId: data.membershipId || "",
          institute: data.instituteName || "",
          city: data.city || "",
          country: data.country || "",
          designation: "",
          postalAddress: "",
          postalPin: "",
          mealPreference: "veg",
          age: "",
          paymentAmount: amount,
          registrationType: regType,
          payLater: false,
        });
        setFetched(true);
      } catch (error) {
        console.log(error.message);
      }
    } else {
      setShowError(true);
      setErrorMessage("Session expired. Please login again.");
      navigate("/registration");
    }
  };

  // useEffect(() => {
  //   if (formData.category) {
  //     const availableTypes = getAvailableRegistrationTypes(formData.category);

  //     let selectedType = "";

  //     if (
  //       [
  //         "oncology-or-physicist",
  //         "oncologist&physicist",
  //         "ampi-senior",
  //       ].includes(formData.category)
  //     ) {
  //       selectedType = "early-bird";
  //     } else {
  //       selectedType = availableTypes.length > 0 ? availableTypes[0].value : "";
  //     }

  //     setFormData((prevData) => ({
  //       ...prevData,
  //       registrationType: selectedType,
  //     }));
  //   }
  // }, [formData.category]);

  useEffect(() => {
    if (formData.category) {
      const availableTypes = getAvailableRegistrationTypes(formData.category);
      const todayBasedRegType = determineRegistrationType();

      let selectedType = "";

      if (
        [
          "oncology-or-physicist",
          "oncologist&physicist",
          "ampi-senior",
        ].includes(formData.category)
      ) {
        selectedType = "early-bird";
      } else {
        // Prefer today's matching registration type
        selectedType =
          availableTypes.find((t) => t.value === todayBasedRegType)?.value ||
          (availableTypes.length > 0 ? availableTypes[0].value : "");
      }

      setFormData((prevData) => ({
        ...prevData,
        registrationType: selectedType,
      }));
    } else {
      setFormData((prevData) => ({
        ...prevData,
        registrationType: "",
      }));
    }
  }, [formData.category]);

  useEffect(() => {
    fetchUserData();
    // eslint-disable-next-line
  }, [regUserId]);

  // Function to determine the registration period
  const determineRegistrationType = () => {
    const currentDate = new Date();
    const earlyBirdEndDate = new Date("August 15, 2025 23:59:59");
    const regularEndDate = new Date("September 10, 2025 23:59:59");
    const conferenceStartDate = new Date("October 3, 2025");

    console.log("Current Date:", currentDate);
    console.log("📅 Early Bird Deadline:", earlyBirdEndDate.toString());
    console.log("Early Bird Passed:", currentDate > earlyBirdEndDate);
    console.log("Regular Passed:", currentDate > regularEndDate);
    console.log("Conference Started:", currentDate > conferenceStartDate);

    if (currentDate <= earlyBirdEndDate) {
      return "early-bird";
    } else if (currentDate <= regularEndDate) {
      return "regular";
    } else if (currentDate <= conferenceStartDate) {
      return "onsite";
    } else {
      return "";
    }
  };

  // Set the registration type on component mount
  useEffect(() => {
    const regType = determineRegistrationType();
    setFormData((prevData) => ({
      ...prevData,
      registrationType: regType,
    }));
  }, []);

  // Calculate payment amount based on category and registration type
  const calculatePaymentAmount = (category, regType) => {
    const fees = {
      ampi: {
        "early-bird": 1500,
        regular: 1750,
        onsite: 2000,
      },
      "non-ampi": {
        "early-bird": 2000,
        regular: 2500,
        onsite: 3000,
      },
      associate: {
        "early-bird": 1000,
        regular: 1250,
        onsite: 1500,
      },
      student: {
        "early-bird": 1000,
        regular: 1000,
        onsite: 1500,
      },
      overseas: {
        // "early-bird": 100 * 80,
        "early-bird": 8736,
        regular: 120 * 87,
        onsite: 150 * 87,
      },
      "oncologist&physicist": {
        "early-bird": 5000,
        regular: 5000,
        onsite: 5000,
      },
      "oncology-or-physicist": {
        "early-bird": 3000,
        regular: 3000,
        onsite: 3000,
      },
      "ampi-senior": {
        "early-bird": 1,
        regular: 1,
        onsite: 1,
      },
      "apollo-staff": {
        "early-bird": 1,
        regular: 1,
        onsite: 1,
      },
      tradedelegates: {
        "early-bird": 3000,
        regular: 5000,
        onsite: 7000,
      },
      rtt: {
        "early-bird": 250,
        regular: 500,
        onsite: 1000,
      },
    };

    return fees[category]?.[regType] || 0;
  };

  const getAvailableRegistrationTypes = (category) => {
    const currentDate = new Date();
    const earlyBirdEndDate = new Date("2025-08-15T23:59:59+05:30");
    const regularEndDate = new Date("September 10, 2025 23:59:59");

    // Special cases for specific categories
    if (["oncology-or-physicist", "oncologist&physicist"].includes(category)) {
      return [{ value: "early-bird", label: "Fixed Registration" }];
    }

    if (category === "ampi-senior" || category === "apollo-staff") {
      return [{ value: "early-bird", label: "Complimentary Registration" }];
    }

    // For student category, allow early-bird and regular based on date
    if (category === "student") {
      const types = [];
      if (currentDate <= earlyBirdEndDate) {
        types.push({
          value: "early-bird",
          label: "Early Bird Registration (Up to 15th August)",
        });
      }
      if (currentDate <= regularEndDate) {
        types.push({
          value: "regular",
          label: "Regular Registration (Up to 10th September)",
        });
      }
      if (currentDate > regularEndDate) {
        types.push({
          value: "onsite",
          label: "On Site Registration (From 11th September)",
        });
      }
      return types;
    }

    // For other categories, show options based on current date
    const availableTypes = [];
    if (currentDate <= earlyBirdEndDate) {
      availableTypes.push({
        value: "early-bird",
        label: "Early Bird Registration (Up to 15th August)",
      });
    }
    if (currentDate <= regularEndDate) {
      availableTypes.push({
        value: "regular",
        label: "Regular Registration (Up to 10th September)",
      });
    }
    if (currentDate > regularEndDate) {
      availableTypes.push({
        value: "onsite",
        label: "On Site Registration (From 11th September)",
      });
    }
    return availableTypes;
  };

  // Update payment amount when category or registration type changes
  useEffect(() => {
    if (formData.category) {
      const amount = calculatePaymentAmount(
        formData.category,
        formData.registrationType
      );
      setFormData((prevData) => ({
        ...prevData,
        paymentAmount: amount,
      }));
    }
  }, [formData.category, formData.registrationType]);

  useEffect(() => {
    if (formData.category) {
      const availableTypes = getAvailableRegistrationTypes(formData.category);
      const todayBasedRegType = determineRegistrationType();

      let selectedType = "";

      if (
        [
          "oncology-or-physicist",
          "oncologist&physicist",
          "ampi-senior",
        ].includes(formData.category)
      ) {
        selectedType = "early-bird";
      } else {
        // Prefer today's matching registration type
        selectedType =
          availableTypes.find((t) => t.value === todayBasedRegType)?.value ||
          (availableTypes.length > 0 ? availableTypes[0].value : "");
      }

      setFormData((prevData) => ({
        ...prevData,
        registrationType: selectedType,
      }));
    } else {
      setFormData((prevData) => ({
        ...prevData,
        registrationType: "",
      }));
    }
  }, [formData.category]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === "checkbox" ? checked : value,
    });
  };

  const loadScript = (src) => {
    return new Promise((resolve) => {
      const script = document.createElement("script");
      script.src = src;
      script.onload = () => resolve(true);
      script.onerror = () => resolve(false);
      document.body.appendChild(script);
    });
  };

  const handleRazorpayPayment = async () => {
    const regUserId =
      localStorage.getItem("userId") || sessionStorage.getItem("userId");

    // Load Razorpay script
    const scriptLoaded = await loadScript(
      "https://checkout.razorpay.com/v1/checkout.js"
    );

    if (!scriptLoaded) {
      setShowError(true);
      setErrorMessage(
        "Failed to load Razorpay SDK. Please check your connection."
      );
      return;
    }

    const options = {
      key: "rzp_live_Kd1UK5owEFRAOA",
      amount: formData.paymentAmount * 100,
      // amount: 20 * 100,
      currency: "INR",
      name: "TN PY AMPICON 2025",
      description: `Registration for ${getCategoryLabel(formData.category)}`,
      handler: async (response) => {
        console.log("Payment Successful:", response);

        try {
          const pushingData = new FormData();
          pushingData.append("userName", formData.name);
          pushingData.append("userTitle", formData.title);
          pushingData.append("mobileNumber", formData.mobile);
          pushingData.append("registrationCategory", formData.category);
          pushingData.append("membershipId", formData.membershipId);
          pushingData.append("instituteName", formData.institute);
          pushingData.append("city", formData.city);
          pushingData.append("country", formData.country);
          pushingData.append("designation", formData.designation);
          pushingData.append("postalAddress", formData.postalAddress);
          pushingData.append("mealPreference", formData.mealPreference);
          pushingData.append("postalPin", formData.postalPin);
          pushingData.append("age", formData.age);
          pushingData.append("paymentAmount", formData.paymentAmount);
          pushingData.append("registrationType", formData.registrationType);
          pushingData.append("payLater", "NO");
          pushingData.append("paymentStatus", "PAID");
          pushingData.append("payment_id", response.razorpay_payment_id);
          pushingData.append(
            "payment_date",
            new Date().toLocaleString("en-IN", { timeZone: "Asia/Kolkata" })
          );

          const updateResponse = await axios.put(
            `https://api.dremerz.net/api/DZ_8921_Ampicon_Create_Users_UserList/${regUserId}`,
            pushingData
          );

          if (updateResponse.status === 200) {
            setRegistrationSuccess(true);
            setSuccessMessage("Payment successful! Registration completed.");
            navigate("/abstract-submission");
          } else {
            setShowError(true);
            setErrorMessage(
              "Payment successful but failed to update registration. Please contact support."
            );
          }
        } catch (error) {
          console.error("Error updating registration after payment:", error);
          setShowError(true);
          setErrorMessage(
            `Payment successful but failed to update registration. Please contact support with your payment ID: ${response.razorpay_payment_id}`
          );
        }
      },
      prefill: {
        name: formData.name,
        email: formData.email,
        contact: formData.mobile,
      },
      notes: {
        userId: regUserId,
        category: formData.category,
        registrationType: formData.registrationType,
      },
      theme: {
        color: "#2582A1",
      },
      modal: {
        ondismiss: function () {
          console.log("Payment modal closed");
        },
      },
    };

    const paymentObject = new window.Razorpay(options);
    paymentObject.open();
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const regUserId =
      localStorage.getItem("userId") || sessionStorage.getItem("userId");

    // Basic validation
    if (
      !formData.name ||
      !formData.email ||
      !formData.mobile ||
      !formData.designation ||
      !formData.postalAddress ||
      !formData.postalPin ||
      !formData.category
    ) {
      setShowError(true);
      setErrorMessage("Please fill in all required fields");
      return;
    }

    // Email validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(formData.email)) {
      setShowError(true);
      setErrorMessage("Please enter a valid email address");
      return;
    }

    // Mobile validation (basic)
    const mobileRegex = /^\d{10}$/;
    if (!mobileRegex.test(formData.mobile)) {
      setShowError(true);
      setErrorMessage("Please enter a valid 10-digit mobile number");
      return;
    }

    // Postal PIN validation
    const pinRegex = /^\d{6}$/;
    if (!pinRegex.test(formData.postalPin)) {
      setShowError(true);
      setErrorMessage("Please enter a valid 6-digit PIN code");
      return;
    }

    // Age validation (if provided)
    if (
      formData.age &&
      (isNaN(formData.age) || formData.age < 18 || formData.age > 100)
    ) {
      setShowError(true);
      setErrorMessage("Please enter a valid age between 18 and 100");
      return;
    }

    // Validate membership ID for AMPI members
    if (formData.category === "ampi" && !formData.membershipId) {
      setShowError(true);
      setErrorMessage("Please enter your membership ID");
      return;
    }

    // Registration type date validation
    const currentDate = new Date();
    const earlyBirdEndDate = new Date("2025-08-15T23:59:59+05:30");
    const regularEndDate = new Date("September 10, 2025 23:59:59");

    // Skip date validation for fixed/complimentary categories
    const fixedCategories = [
      "oncology-or-physicist",
      "oncologist&physicist",
      "ampi-senior",
      "apollo-staff",
    ];
    if (!fixedCategories.includes(formData.category)) {
      // Validate if selected registration type matches current date
      if (
        formData.registrationType === "early-bird" &&
        currentDate > earlyBirdEndDate
      ) {
        setShowError(true);
        setErrorMessage(
          "Early bird registration period has ended. Please select Regular or Onsite registration."
        );
        return;
      }

      if (
        formData.registrationType === "regular" &&
        currentDate > regularEndDate
      ) {
        setShowError(true);
        setErrorMessage(
          "Regular registration period has ended. Please select Onsite registration."
        );
        return;
      }

      if (
        formData.registrationType === "onsite" &&
        currentDate < regularEndDate
      ) {
        setShowError(true);
        setErrorMessage(
          "Onsite registration is not yet available. Please select Early Bird or Regular registration."
        );
        return;
      }
    }

    try {
      setIsLoading(true);

      // If user chooses to pay later or has complimentary registration
      if (formData.payLater || formData.category === "") {
        const pushingData = new FormData();
        pushingData.append("userName", formData.name);
        pushingData.append("userTitle", formData.title);
        pushingData.append("mobileNumber", formData.mobile);
        pushingData.append("registrationCategory", formData.category);
        pushingData.append("membershipId", formData.membershipId);
        pushingData.append("instituteName", formData.institute);
        pushingData.append("city", formData.city);
        pushingData.append("country", formData.country);
        pushingData.append("designation", formData.designation);
        pushingData.append("postalAddress", formData.postalAddress);
        pushingData.append("mealPreference", formData.mealPreference);
        pushingData.append("postalPin", formData.postalPin);
        pushingData.append("age", formData.age);
        pushingData.append("paymentAmount", formData.paymentAmount);
        pushingData.append("registrationType", formData.registrationType);
        pushingData.append("payLater", formData.payLater ? "YES" : "NO");

        // Set payment status
        if (formData.category === "") {
          pushingData.append("paymentStatus", "COMPLIMENTARY");
        } else if (formData.payLater) {
          pushingData.append("paymentStatus", "PENDING");
        }

        const response = await axios.put(
          `https://api.dremerz.net/api/DZ_8921_Ampicon_Create_Users_UserList/${regUserId}`,
          pushingData
        );

        setIsLoading(false);
        setRegistrationSuccess(true);

        setTimeout(() => {
          if (formData.category === "ampi-senior") {
            navigate("/userProfile");
          } else {
            navigate("/userProfile", {
              state: { paymentAmount: formData.paymentAmount },
            });
          }
        }, 1000);
      } else {
        // User wants to pay now - initiate Razorpay payment
        setIsLoading(false);
        await handleRazorpayPayment();
      }
    } catch (error) {
      setIsLoading(false);
      setShowError(true);
      setErrorMessage(
        "An error occurred during registration. Please try again."
      );
      console.error("Registration error:", error);
    }
  };
  console.log("Today’s Reg Type:", determineRegistrationType());
  console.log(
    "Available Types:",
    getAvailableRegistrationTypes(formData.category)
  );

  const getCategoryLabel = (category) => {
    const categories = {
      ampi: "AMPI Member",
      "non-ampi": "Non AMPI Member",
      associate: "Associate Delegate",
      "ampi-senior": "Senior AMPI Member (60+)",
      "apollo-staff": "Apollo Staff",
      "senior-75": "Senior AMPI Member (75+)",
      student: "Student (Medical Physics)",
      overseas: "Overseas Delegate",
      "oncology-or-physicist": "Oncology or Physicist",
      "oncologist&physicist": "Oncology and Physicist",
      tradedelegates: "Trade Delegates",
      rtt: "RTT",
    };
    return categories[category] || category;
  };

  const getRegistrationTypeLabel = (type, category) => {
    if (["ampi-senior", "apollo-staff"].includes(category)) {
      return "Complimentary Registration";
    }
    if (["oncology-or-physicist", "oncologist&physicist"].includes(category)) {
      return "Fixed Registration";
    }
    const types = {
      "early-bird": "Early Bird Registration (Up to 15th August)",
      regular: "Regular Registration (Up to 10th September)",
      onsite: "On Site Registration (From 11th September)",
    };
    return types[type] || type;
  };

  return (
    <div style={{ backgroundColor: "#FFF4FA" }}>
      <style>
        {`
    .custom-nav-link.active {
      background-color: #2582A1 !important;
      border-color: #2582A1 !important;
    }
    .custom-nav-link:not(.active) {
      color: #2582A1 !important;
    }
    .form-control:focus {
      border-color: rgba(37, 130, 161, 0.4);
      box-shadow: 0 0 0 0.25rem rgba(37, 130, 161, 0.25);
    }
    .btn-primary {
      background-color: #2582A1;
      border-color: #2582A1;
    }
    .btn-primary:hover, .btn-primary:focus {
      background-color: #1f6b86;
      border-color: #1f6b86;
    }
    .link-primary {
      color: #2582A1 !important;
      cursor: pointer;
    }
    .link-primary:hover {
      text-decoration: underline !important;
    }
    .payment-summary {
      background-color: #f8f9fa;
      border-radius: 0.5rem;
      padding: 1.5rem;
      box-shadow: inset 0 0 0.5rem rgba(0,0,0,0.05);
    }
    .payment-amount {
      font-size: 2rem;
      font-weight: bold;
      color: #2582A1;
    }
  `}
      </style>

      <FromPageIndicator />

      <div className="text-dark py-4 pb-4">
        <Container>
          <h1 className="text-center mb-2" style={{ color: "#2582A1" }}>
            TN PY AMPICON 2025 Registration & Payment
          </h1>
          <p className="text-center mb-0">
            28th Annual Conference of Association of Medical Physicists of India
            (Tamil Nadu & Puducherry Chapter)
          </p>
        </Container>
      </div>

      <Container className="pb-5">
        <Row>
          <Col lg={8} className="mb-4">
            <Card className="border-0 shadow-sm">
              <Card.Header className="bg-white border-bottom-0 pt-4 px-4">
                <h3 className="mb-0">Complete Registration</h3>
              </Card.Header>
              <Card.Body className="px-4 pb-4">
                <CustomAlert
                  show={showError}
                  onClose={() => setShowError(false)}
                  variant="danger"
                  title="Registration Error"
                  message={errorMessage}
                  dismissible={true}
                  position="fixed-top"
                  animation="slide"
                  autoClose={true}
                  autoCloseDelay={6000}
                />

                <CustomAlert
                  show={registrationSuccess}
                  onClose={() => setRegistrationSuccess(false)}
                  variant="success"
                  title="Registration Successful!"
                  message={
                    successMessage ||
                    "Registration completed successfully! Redirecting..."
                  }
                  dismissible={true}
                  position="fixed-top"
                  animation="slide"
                  autoClose={true}
                  autoCloseDelay={3000}
                />

                <Form onSubmit={handleSubmit}>
                  <Row className="mb-3">
                    <Col md={12} className="mb-3">
                      <Form.Group controlId="formName">
                        <Form.Label className="fw-semibold">
                          Full Name <span className="text-danger">*</span>
                        </Form.Label>
                        <div className="input-group">
                          <span className="input-group-text bg-light">
                            <Person />
                          </span>
                          <Form.Control
                            type="text"
                            placeholder="Enter your full name"
                            name="name"
                            value={formData.name}
                            onChange={handleChange}
                            required
                            className="py-2"
                          />
                        </div>
                      </Form.Group>
                    </Col>
                  </Row>

                  <Row className="mb-3">
                    <Col md={6} className="mb-3 mb-md-0">
                      <Form.Group controlId="formDesignation">
                        <Form.Label className="fw-semibold">
                          Designation <span className="text-danger">*</span>
                        </Form.Label>
                        <div className="input-group">
                          <span className="input-group-text bg-light">
                            <Briefcase />
                          </span>
                          <Form.Control
                            type="text"
                            placeholder="Enter your designation"
                            name="designation"
                            value={formData.designation}
                            onChange={handleChange}
                            required
                            className="py-2"
                          />
                        </div>
                      </Form.Group>
                    </Col>

                    <Col md={6}>
                      <Form.Group controlId="formAge">
                        <Form.Label className="fw-semibold">Age</Form.Label>
                        <div className="input-group">
                          <span className="input-group-text bg-light">
                            <Calendar3 />
                          </span>
                          <Form.Control
                            type="number"
                            placeholder="Enter your age"
                            name="age"
                            value={formData.age}
                            onChange={handleChange}
                            className="py-2"
                            required
                          />
                        </div>
                      </Form.Group>
                    </Col>
                  </Row>

                  <Row className="mb-3">
                    <Col md={6} className="mb-3 mb-md-0">
                      <Form.Group controlId="formEmail">
                        <Form.Label className="fw-semibold">
                          Email Address <span className="text-danger">*</span>
                        </Form.Label>
                        <div className="input-group">
                          <span className="input-group-text bg-light">
                            <EnvelopeFill />
                          </span>
                          <Form.Control
                            type="email"
                            placeholder="Enter your email address"
                            name="email"
                            value={formData.email}
                            onChange={handleChange}
                            required
                            className="py-2"
                          />
                        </div>
                      </Form.Group>
                    </Col>

                    <Col md={6}>
                      <Form.Group controlId="formMobile">
                        <Form.Label className="fw-semibold">
                          Mobile Number <span className="text-danger">*</span>
                        </Form.Label>
                        <div className="input-group">
                          <span className="input-group-text bg-light">
                            <TelephoneFill />
                          </span>
                          <Form.Control
                            type="text"
                            placeholder="Enter your 10-digit mobile number"
                            name="mobile"
                            value={formData.mobile}
                            onChange={handleChange}
                            required
                            className="py-2"
                          />
                        </div>
                      </Form.Group>
                    </Col>
                  </Row>

                  <Row className="mb-3">
                    <Col md={12}>
                      <Form.Group controlId="formPostalAddress">
                        <Form.Label className="fw-semibold">
                          Postal Address <span className="text-danger">*</span>
                        </Form.Label>
                        <div className="input-group">
                          <span className="input-group-text bg-light">
                            <House />
                          </span>
                          <Form.Control
                            as="textarea"
                            rows={3}
                            placeholder="Enter your complete postal address"
                            name="postalAddress"
                            value={formData.postalAddress}
                            onChange={handleChange}
                            required
                            className="py-2"
                          />
                        </div>
                      </Form.Group>
                    </Col>
                  </Row>

                  <Row className="mb-3">
                    <Col md={6} className="mb-3 mb-md-0">
                      <Form.Group controlId="formPostalPin">
                        <Form.Label className="fw-semibold">
                          Postal PIN Code <span className="text-danger">*</span>
                        </Form.Label>
                        <div className="input-group">
                          <span className="input-group-text bg-light">
                            <Tag />
                          </span>
                          <Form.Control
                            type="text"
                            placeholder="Enter 6-digit PIN code"
                            name="postalPin"
                            value={formData.postalPin}
                            onChange={handleChange}
                            required
                            className="py-2"
                            maxLength="6"
                          />
                        </div>
                      </Form.Group>
                    </Col>

                    <Col md={6}>
                      <Form.Group controlId="formMealPreference">
                        <Form.Label className="fw-semibold">
                          Meal Preference <span className="text-danger">*</span>
                        </Form.Label>
                        <div className="d-flex">
                          <Form.Check
                            type="radio"
                            id="meal-veg"
                            label="Vegetarian"
                            name="mealPreference"
                            value="veg"
                            checked={formData.mealPreference === "veg"}
                            onChange={handleChange}
                            className="me-4"
                          />
                          <Form.Check
                            type="radio"
                            id="meal-nonveg"
                            label="Non-Vegetarian"
                            name="mealPreference"
                            value="non-veg"
                            checked={formData.mealPreference === "non-veg"}
                            onChange={handleChange}
                          />
                        </div>
                      </Form.Group>
                    </Col>
                  </Row>

                  <Row className="mb-3">
                    <Col md={6} className="mb-3 mb-md-0">
                      <Form.Group controlId="formInstitute">
                        <Form.Label className="fw-semibold">
                          Institution/Organization
                        </Form.Label>
                        <div className="input-group">
                          <span className="input-group-text bg-light">
                            <BuildingFill />
                          </span>
                          <Form.Control
                            type="text"
                            placeholder="Enter your institution name"
                            name="institute"
                            value={formData.institute}
                            onChange={handleChange}
                            className="py-2"
                          />
                        </div>
                      </Form.Group>
                    </Col>

                    <Col md={6}>
                      <Form.Group controlId="formCity">
                        <Form.Label className="fw-semibold">City</Form.Label>
                        <div className="input-group">
                          <span className="input-group-text bg-light">
                            <GeoAltFill />
                          </span>
                          <Form.Control
                            type="text"
                            placeholder="Enter city"
                            name="city"
                            value={formData.city}
                            onChange={handleChange}
                            className="py-2"
                          />
                        </div>
                      </Form.Group>
                    </Col>
                  </Row>

                  <Row className="mb-3">
                    <Col md={12}>
                      <Form.Group controlId="formCountry">
                        <Form.Label className="fw-semibold">Country</Form.Label>
                        <div className="input-group">
                          <span className="input-group-text bg-light">
                            <Globe />
                          </span>
                          <Form.Select
                            as="select"
                            name="country"
                            value={formData.country}
                            onChange={handleChange}
                            className="py-2"
                          >
                            <option value="India">India</option>
                            <option value="Afghanistan">Afghanistan</option>
                            <option value="Bangladesh">Bangladesh</option>
                            <option value="Bhutan">Bhutan</option>
                            <option value="Maldives">Maldives</option>
                            <option value="Nepal">Nepal</option>
                            <option value="Pakistan">Pakistan</option>
                            <option value="Sri Lanka">Sri Lanka</option>
                            <option value="Other">Other</option>
                          </Form.Select>
                        </div>
                      </Form.Group>
                    </Col>
                  </Row>

                  <Form.Group controlId="formCategory" className="mb-3">
                    <Form.Label className="fw-semibold">
                      Registration Category{" "}
                      <span className="text-danger">*</span>
                    </Form.Label>
                    <Form.Select
                      as="select"
                      name="category"
                      value={formData.category}
                      onChange={handleChange}
                      required
                      className="py-2"
                    >
                      <option value="">Select Category</option>
                      <option value="ampi">AMPI & AROI Member</option>
                      <option value="non-ampi">
                        Non AMPI & non AROI Member
                      </option>
                      <option value="associate">Associate Delegate</option>
                      <option value="student">Student (Medical Physics)</option>
                      <option value="overseas">Overseas Delegate</option>
                      <option value="oncologist&physicist">
                        Oncologist + Physicist Team
                      </option>
                      <option value="oncology-or-physicist">
                        Oncologist or Medical Physicist
                      </option>
                      <option value="tradedelegates">Trade Delegates</option>
                      <option value="ampi-senior">
                        AMPI Senior Member (60+)
                      </option>
                      <option value="apollo-staff">Apollo Staff</option>
                      <option value="rtt">RTT</option>
                    </Form.Select>
                  </Form.Group>
                  <Form.Group controlId="formRegistrationType" className="mb-3">
                    <Form.Label className="fw-semibold">
                      Registration Type <span className="text-danger">*</span>
                    </Form.Label>
                    <Form.Select
                      name="registrationType"
                      value={formData.registrationType}
                      onChange={handleChange}
                      required
                      className="py-2"
                      // disabled={[
                      //   "oncology-or-physicist",
                      //   "oncologist&physicist",
                      //   "ampi-senior",
                      // ].includes(formData.category)}
                    >
                      <option value="">Select Registration Type</option>
                      {formData.category &&
                        getAvailableRegistrationTypes(formData.category).map(
                          (type) => (
                            <option key={type.value} value={type.value}>
                              {type.label}
                            </option>
                          )
                        )}
                    </Form.Select>
                    {formData.category === "student" && (
                      <Form.Text className="text-muted">
                        Student registrations are only available during the
                        regular period.
                      </Form.Text>
                    )}
                    {["oncology-or-physicist", "oncologist&physicist"].includes(
                      formData.category
                    ) && (
                      <Form.Text className="text-muted">
                        This category includes both workshop and conference
                        access.
                      </Form.Text>
                    )}
                    {formData.category === "ampi-senior" && (
                      <Form.Text className="text-muted">
                        Senior AMPI members (60+) get complimentary
                        registration.
                      </Form.Text>
                    )}
                  </Form.Group>

                  {formData.category === "ampi" && (
                    <Form.Group controlId="formMembership" className="mb-3">
                      <Form.Label className="fw-semibold">
                        AMPI or AROI Membership ID{" "}
                        <span className="text-danger">*</span>
                      </Form.Label>
                      <Form.Control
                        type="text"
                        placeholder="Enter your membership ID"
                        name="membershipId"
                        value={formData.membershipId}
                        onChange={handleChange}
                        required
                        className="py-2"
                      />
                    </Form.Group>
                  )}

                  <Form.Group className="mb-4">
                    <Form.Check
                      type="checkbox"
                      id="termsCheck"
                      label="I agree to the terms and conditions"
                      required
                    />
                  </Form.Group>

                  {formData.category !== "ampi-senior" && !fetched && (
                    <Form.Group className="mb-4">
                      <Form.Check
                        type="checkbox"
                        id="payLaterCheck"
                        label="I want to pay later"
                        name="payLater"
                        checked={formData.payLater}
                        onChange={handleChange}
                      />
                    </Form.Group>
                  )}

                  <div className="d-grid">
                    <Button
                      type="submit"
                      size="lg"
                      className="py-2 btn-primary"
                      disabled={isLoading}
                    >
                      {isLoading ? (
                        <>
                          <Spinner
                            as="span"
                            animation="border"
                            size="sm"
                            className="me-2"
                          />
                          Processing...
                        </>
                      ) : formData.payLater ? (
                        "Complete Registration (Pay Later)"
                      ) : (
                        "Proceed to Payment"
                      )}
                    </Button>
                  </div>
                </Form>
              </Card.Body>
            </Card>
          </Col>

          <Col lg={4}>
            <div className="sticky-top" style={{ top: "2rem" }}>
              <Card className="border-0 shadow-sm mb-4">
                <Card.Header className="bg-white border-bottom-0 pt-4 px-4">
                  <h3 className="mb-0">Payment Summary</h3>
                </Card.Header>
                <Card.Body className="px-4 pb-4">
                  <div className="payment-summary mb-3">
                    <div className="d-flex justify-content-between align-items-center mb-3">
                      <span className="fw-semibold">Registration Period:</span>
                      <span className="text-primary">
                        {getRegistrationTypeLabel(
                          formData.registrationType,
                          formData.category
                        )}
                      </span>
                    </div>

                    {formData.category && (
                      <div className="d-flex justify-content-between align-items-center mb-3">
                        <span className="fw-semibold">Category:</span>
                        <span>{getCategoryLabel(formData.category)}</span>
                      </div>
                    )}

                    <hr />

                    <div className="d-flex justify-content-between align-items-center">
                      <span className="fw-semibold">Registration Fee:</span>
                      <div className="payment-amount">
                        {/* <CurrencyDollar className="me-1" /> */}
                        {formData.category === "overseas" ? (
                          <span>
                            ${(formData.paymentAmount / 86).toFixed(3)}
                          </span>
                        ) : (
                          <span>₹{formData.paymentAmount}</span>
                        )}
                      </div>
                    </div>
                  </div>

                  <div className="d-flex align-items-center justify-content-center mb-4">
                    <CreditCard size={24} className="me-2 text-primary" />
                    <span>Secure payment processed via Payment Gateway</span>
                  </div>

                  <CustomAlert
                    show={true}
                    variant="info"
                    title="Important"
                    message="You will be redirected to the payment gateway after completing this form. Please keep your payment details ready."
                    dismissible={false}
                    position="relative"
                    overlay={false}
                  />

                  <div className="small text-muted mt-4">
                    <h6>Registration Fee Includes:</h6>
                    <ul>
                      <li>Entry to all scientific sessions</li>
                      <li>Conference kit and materials</li>
                      <li>Lunch and refreshments for both days</li>
                      <li>Certificate of participation</li>
                    </ul>
                  </div>
                </Card.Body>
              </Card>

              <Card className="border-0 shadow-sm bg-light">
                <Card.Body className="p-4">
                  <h5>Need Help?</h5>
                  <p className="mb-0">
                    For registration or payment queries, contact us at:
                  </p>
                  <p className="mb-0">
                    <strong>Email:</strong>{" "}
                    <a href="mailto:tnpyampicon2025@gmail.com">
                      tnpyampicon2025@gmail.com
                    </a>
                  </p>

                  <p>
                    <strong>Phone:</strong> +91 9994432135
                  </p>
                </Card.Body>
              </Card>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default PaymentPage;
